import React, { useMemo } from 'react';
import { Field, useField, useFormikContext } from 'formik';
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';

const CheckboxGroupField = (props) => {
  const { name, options, justifycontent, label, disabled, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { values } = useFormikContext();

  function _onChange(val, label) {
    let _arr = field.value || [];
    if(val) {
      _arr.push(label)
    } else {
      let index = _arr.indexOf(label);
      _arr = _arr.filter((_, i) => i !== index);
    }
    setValue(_arr);
  }

  const isDisabled = useMemo(() => {
    if (props.disabled) {
      return true;
    }

    if (Array.isArray(props.disabledDependsOnFields) && props.disabledDependsOnFields.length > 0) {
      for (const dep of props.disabledDependsOnFields) {
        if (dep.disabledDepends && dep.disabledValidationValue !== undefined) {
          const dependsKey = dep.disabledDepends.includes('.') ? dep.disabledDepends.split('.') : dep.disabledDepends;
          const dependsValue = dep.disabledDepends.includes('.')
            ? values[dependsKey[0]]?.[dependsKey[1]]
            : values[dependsKey];
          if (dependsValue === dep.disabledValidationValue) {
            return true;
          }
        }
      }
    } else if (props.disabledDepends && props.disabledValidationValue !== undefined) {
      const dependsKey = props.disabledDepends.includes('.') ? props.disabledDepends.split('.') : props.disabledDepends;
      const dependsValue = props.disabledDepends?.includes('.')
        ? values[dependsKey[0]]?.[dependsKey[1]]
        : values[dependsKey];
      if (dependsValue === props.disabledValidationValue) {
        return true;
      }
    }
    return false;
  }, [values, props.disabledDepends, props.disabledValidationValue, props.disabled, props.disabledDependsOnFields]);

  return (
    <Box sx={{ height: justifycontent ? 'auto' : '100%', display: 'flex', flexDirection: 'column', justifyContent: justifycontent ? "start" : "space-between", }}>
      <Typography sx={{ color: '#5b5b5b', fontWeight: 'medium' }} variant='subtitle1' gutterBottom>{label}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column',rowGap:1 }}>
      <FormGroup>
        {options.map((option) => (
          <FormControlLabel disabled={isDisabled} key={`${option}`} value={field.value && field.value.includes(option)}
          checked={field.value && field.value.includes(option)} control={<Checkbox onChange={(e) => _onChange(e.target.checked, option)}/>} label={option}/>
        ))}
        </FormGroup>
      </Box>
    </Box>
  );
};

export default React.memo(CheckboxGroupField);